export default __webpack_public_path__ + "static/media/icon-search.06d00abc.svg";